export const accessTypes: any = {
  READ_ACCESS: 'Read Access',
  WRITE_ACCESS: 'Write Access',
};